export default {
  computed: {
    menu: function () {
      var mainMenu = this.$store.state.AuthenticationStore.menu.menu
   
      var newMenu = []
      mainMenu.map(function (menu) {
        if (menu.features[0].type === 1 || menu.features[0].type === '1') {
          newMenu.push(Object.assign(menu, { model: false }))
        }
      })
      return newMenu
    },
    $update () {
      var mainMenu = this.$store.state.AuthenticationStore.menu.menu
      var crud = []
      mainMenu.map(function (menu) {
        if (menu.features[0].type === 2 || menu.features[0].type === '2') {
          crud.push(Object.assign(menu, {model: false}))
        }
      })
  
      // For some reason, there were cases where the switch statement would raise an exception
      // The check for length was necessary in order to handle the error
      // Based on testing, this doesn't seem to happen in $foc and $creditNote; further observation required
      if (crud.length === 0){
        return false
      }
      else {
        switch (crud[0].features.length) {
          case 0:
            return false
            break
          case 1:
            if (crud[0].features[0].public_id === 'ereer') {
              return true
            } else {
              return false
            }
            break
          case 2:
            if (crud[0].features[0].public_id === 'ereer') {
              return true
            } else if (crud[0].features[1].public_id === 'ereer') {
              return true
            } else {
              return false
            }
            break
          case 3:
            if (crud[0].features[0].public_id === 'ereer') {
              return true
            } else if (crud[0].features[1].public_id === 'ereer') {
              return true
            } else if (crud[0].features[2].public_id === 'ereer') {
              return true
            } else {
              return false
            }
            break
          default:
            return false
        }
      }
    },
    $foc () {
      var mainMenu = this.$store.state.AuthenticationStore.menu.menu
      var crud = []
      mainMenu.map(function (menu) {
        if (menu.features[0].type === 2 || menu.features[0].type === '2') {
          crud.push(Object.assign(menu, {model: false}))
        }
      })
      switch (crud[0].features.length) {
        case 0:
          return false
          break
        case 1:
          if (crud[0].features[0].public_id === '45o722g3') {
            return true
          } else {
            return false
          }
          break
        case 2:
          if (crud[0].features[0].public_id === '45o722g3') {
            return true
          } else if (crud[0].features[1].public_id === '45o722g3') {
            return true
          } else {
            return false
          }
          break
        case 3:
          if (crud[0].features[0].public_id === '45o722g3') {
            return true
          } else if (crud[0].features[1].public_id === '45o722g3') {
            return true
          } else if (crud[0].features[2].public_id === '45o722g3') {
            return true
          } else {
            return false
          }
          break
        default:
          return false
      }
      // if (crud.length > 0) {
      //   if (crud[0].features[0].public_id === '45o722g3') {
      //     return true
      //   } else if (crud[0].features[1].public_id === '45o722g3') {
      //     return true
      //   } else {
      //     return false
      //   }
      // } else {
      //   return false
      // }
    },
    $creditNote () {
      var mainMenu = this.$store.state.AuthenticationStore.menu.menu
      var crud = []
      mainMenu.map(function (menu) {
        if (menu.features[0].type === 2 || menu.features[0].type === '2') {
          crud.push(Object.assign(menu, {model: false}))
        }
      })
      switch (crud[0].features.length) {
        case 0:
          return false
          break
        case 1:
          if (crud[0].features[0].public_id === 'ffa4a138') {
            return true
          } else {
            return false
          }
          break
        case 2:
          if (crud[0].features[0].public_id === 'ffa4a138') {
            return true
          } else if (crud[0].features[1].public_id === 'ffa4a138') {
            return true
          } else {
            return false
          }
          break
        case 3:
          if (crud[0].features[0].public_id === 'ffa4a138') {
            return true
          } else if (crud[0].features[1].public_id === 'ffa4a138') {
            return true
          } else if (crud[0].features[2].public_id === 'ffa4a138') {
            return true
          } else {
            return false
          }
          break
        default:
          return false
      }
    },
    $user_type: function () {
      return this.$store.state.AuthenticationStore.menu.user_type
    },
    $user_type_id: function () {
      return this.$store.state.AuthenticationStore.menu.user_type_id
    }
  }
}
